import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import Portfolio from "../PortfolioImage/portfolio";
import PortfolioSCIIOS from "../../images/sci-chronicle-prototype.png";
import PortfolioSCIChronicle from "../../images/sci-chronicle.png";
import PortfolioSCIDesign from "../../images/sci-design-systems.png";
import PortfolioSCIWeb from "../../images/sci-webapp.png";
import PortfolioSCIFeedback from "../../images/sci-feedback.png";
import PortfolioProcUDesign from "../../images/procu-design-system.png";
import PortfolioProcUFilters from "../../images/procu-filters-prototype.png";
import PortfolioProcUPackage from "../../images/procu-package-prototype.png";
import PortfolioBDSDesign from "../../images/bds-design-system.png";
import PortfolioBDSWeb from "../../images/bds-web.png";
import PortfolioSLMCom from "../../images/slm-com.png";
import PortfolioSLMCalc from "../../images/slm-calc.png";
import PortfolioSLMComponent from "../../images/slm-components.png";
import PortfolioSLMNewToFirm from "../../images/slm-newtofirm.png";
import PortfolioSLMPersonalLoan from "../../images/slm-personal-loan.png";
import PortfolioSLMOLS from "../../images/slm-ols.png";
import PortfolioSLMCollege from "../../images/slm-college.png";
import PortfolioSLMReturn from "../../images/slm-return-borrower.png";
import PortfolioSLMiOS from "../../images/slm-ios.png";
import PortfolioSLMNative from "../../images/slm-native.png";
import PortfolioSLMRate from "../../images/slm-rate.png";
import PortfolioSLMDashboard from "../../images/slm-dashboard.png";

const PortfolioPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);

  return (
    <Container fluid>
      <section id="portfolio">
        <Container>
          <Row>
            <Col xs={12} className="mt-3">
              <Link to="/"><ChevronLeftIcon />Back to Home</Link> {/* Add a button to go back to Home */}
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <h2>StoryCatch Insights</h2>
              <p>As lead UX designer at StoryCatch Insights - a reasearch and technology company specializing in virtual clinical trials, I led the end-to-end design process in Figma, translating product strategy into intuitive, high-impact user experiences. I developed wireframes and interactive prototypes, driving iterative refinement through stakeholder alignment and user-centered thinking, while ensuring design consistency, usability, and seamless handoff to development.</p>
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={6} xl={4}>
              <Portfolio link="https://www.figma.com/proto/Tq1uRqt05udPgUl0RB65Kr/StoryCatch-Partners?node-id=7743-16367&p=f&t=cViSbWHprgird1kX-1&scaling=scale-down&content-scaling=fixed&page-id=5028%3A5106&starting-point-node-id=7743%3A16367&show-proto-sidebar=1" src={PortfolioSCIIOS} figcaption="Figma native iOS app prototype" alt="Figma native iOS app prototype screenshot" />
            </Col>
            <Col xs={12} md={6} xl={4}>
              <Portfolio link="https://www.figma.com/design/Tq1uRqt05udPgUl0RB65Kr/StoryCatch-Partners?node-id=5028-5106&t=NfhCQw3lVYYXDoJk-1" src={PortfolioSCIChronicle} figcaption="Figma native iOS app design" alt="Figma native iOS app design screenshot" />
            </Col>
            <Col xs={12} md={6} xl={4}>
              <Portfolio link="https://www.figma.com/design/Tq1uRqt05udPgUl0RB65Kr/StoryCatch-Partners?node-id=2-8&t=NfhCQw3lVYYXDoJk-1" src={PortfolioSCIDesign} figcaption="Figma design system" alt="Figma design system screenshot" />
            </Col>
            <Col xs={12} md={6} xl={4}>
              <Portfolio link="https://www.webdesignofboston.com/storycatch/" src={PortfolioSCIWeb} figcaption="Web app HTML demo" alt="Web app HTML demo screenshot" />
            </Col>
            <Col xs={12} md={6} xl={4}>
              <Portfolio link="https://www.figma.com/proto/Tq1uRqt05udPgUl0RB65Kr/StoryCatch-Partners?node-id=4756-15401&p=f&t=CQEEZRBpmBaIqkB1-1&scaling=scale-down&content-scaling=fixed&page-id=4040%3A1923&starting-point-node-id=4805%3A16155&show-proto-sidebar=1" src={PortfolioSCIFeedback} figcaption="Figma feedback prototype" alt="Figma feedback prototype screenshot" />
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <h2>ProcessUnity</h2>
              <p>As Lead UX Designer at ProcessUnity, I drove the design of enterprise workflows that help organizations manage third-party risk and compliance. I led the creation and evolution of a scalable design system, developed high-fidelity prototypes to validate complex user flows, and partnered closely with developers to ensure seamless implementation. I also ensured accessibility and regulatory compliance by aligning designs with WCAG standards and contributing to VPAT documentation. My work focused on simplifying data-heavy experiences into intuitive, efficient interfaces that aligned user needs with business objectives.</p>
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={6} xl={4}>
              <Portfolio link="https://www.figma.com/design/xbjRGflo0CPQf1FEXJ75Ko/ProcU?node-id=2-118382&t=7nbGJlaDz3v2wJTz-1" src={PortfolioProcUDesign} figcaption="Figma design system" alt="Figma design system screenshot" />
            </Col>
            <Col xs={12} md={6} xl={4}>
              <Portfolio link="https://www.figma.com/proto/xbjRGflo0CPQf1FEXJ75Ko/ProcU?node-id=2-30211&p=f&t=ZSegQ9cHqA6PneNR-1&scaling=min-zoom&content-scaling=fixed&page-id=1%3A2&starting-point-node-id=2%3A30211&show-proto-sidebar=1" src={PortfolioProcUFilters} figcaption="Figma filters prototype" alt="Figma filters prototype screenshot" />
            </Col>
            <Col xs={12} md={6} xl={4}>
              <Portfolio link="https://www.figma.com/design/xbjRGflo0CPQf1FEXJ75Ko/ProcU?node-id=0-1&t=6YkXowqNCJwBkt7b-1" src={PortfolioProcUPackage} figcaption="Figma package manager prototype" alt="Figma package manager prototype screenshot" />
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <h2>Brookline Driving School</h2>
              <p>As the sole UX designer and developer at Brookline Driving School, I led the end-to-end creation of a responsive, accessible website for a business that provides driver education and road test preparation services. I established and implemented a cohesive design system, developed high-fidelity prototypes to refine user flows, and translated them into a performant, user-friendly site. My work focused on simplifying scheduling and onboarding while ensuring clarity, usability, and consistency across the entire experience.</p>
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={6} xl={4}>
              <Portfolio link="https://www.figma.com/design/PMWnCCIN2u6qpt1l4fLVgV/Brookline-Driving-School?node-id=126-207&t=phX7yPuHUHSg6CS0-1" src={PortfolioBDSDesign} figcaption="Figma design system" alt="Figma design system screenshot" />
            </Col>
            <Col xs={12} md={6} xl={4}>
              <Portfolio link="https://www.brooklinedriving.com/" src={PortfolioBDSWeb} figcaption="Web site" alt="Web site screenshot" />
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <h2>Sallie Mae Bank</h2>
              <p>As Lead Prototyper on the UX team at Sallie Mae Bank, I helped design and deliver digital experiences for a leading provider of student loans and education financing. I partnered closely with designers and developers to translate concepts into high-fidelity, interactive HTML prototypes, writing responsive and accessible code that accurately reflected production behavior. My work enabled rapid iteration, improved collaboration across teams, and ensured that user experiences were both technically feasible and aligned with accessibility best practices.</p>
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={6} xl={4}>
              <Portfolio link="https://www.webdesignofboston.com/portfolio/slm.com/index.html" src={PortfolioSLMCom} figcaption="Salliemae.com HTML demo" alt="Salliemae.com HTML demo screenshot" />
            </Col>
            <Col xs={12} md={6} xl={4}>
              <Portfolio link="https://www.webdesignofboston.com/portfolio/payment-calculator/index.html" src={PortfolioSLMCalc} figcaption="Loan repayment calculator HTML demo" alt="Loan repayment calculator HTML demo screenshot" />
            </Col>
            <Col xs={12} md={6} xl={4}>
              <Portfolio link="https://www.webdesignofboston.com/portfolio/design-system-react/index.html" src={PortfolioSLMComponent} figcaption="React component library" alt="React component library screenshot" />
            </Col>
            <Col xs={12} md={6} xl={4}>
              <Portfolio link="https://www.webdesignofboston.com/portfolio/new-to-firm/index.html" src={PortfolioSLMNewToFirm} figcaption="OLA new to firm HTML demo" alt="OLA new to firm HTML demo screenshot" />
            </Col>
            <Col xs={12} md={6} xl={4}>
              <Portfolio link="https://www.webdesignofboston.com/portfolio/personal-loan/redeem-offer.html" src={PortfolioSLMPersonalLoan} figcaption="Personal loan HTML demo" alt="Personal loan HTML demo screenshot" />
            </Col>
            <Col xs={12} md={6} xl={4}>
              <Portfolio link="https://www.webdesignofboston.com/portfolio/ols/index.html" src={PortfolioSLMOLS} figcaption="OLS HTML demo" alt="OLS HTML demo screenshot" />
            </Col>
            <Col xs={12} md={6} xl={4}>
              <Portfolio link="https://www.webdesignofboston.com/portfolio/college-matching/index.html" src={PortfolioSLMCollege} figcaption="College matching HTML demo" alt="College matching HTML demo screenshot" />
            </Col>
            <Col xs={12} md={6} xl={4}>
              <Portfolio link="https://www.webdesignofboston.com/portfolio/return-borrower/index.html" src={PortfolioSLMReturn} figcaption="Return borrower HTML demo" alt="Return borrower HTML demo screenshot" />
            </Col>
            <Col xs={12} md={6} xl={4}>
              <Portfolio link="https://www.webdesignofboston.com/portfolio/ios-auto-debit/index.html" src={PortfolioSLMiOS} figcaption="iOS auto debit HTML demo" alt="iOS auto debit HTML demo screenshot" />
            </Col>
            <Col xs={12} md={6} xl={4}>
              <Portfolio link="https://www.webdesignofboston.com/portfolio/native-app-evolution/index.html" src={PortfolioSLMNative} figcaption="Native app evolution HTML demo" alt="Native app evolution HTML demo screenshot" />
            </Col>
            <Col xs={12} md={6} xl={4}>
              <Portfolio link="https://www.webdesignofboston.com/portfolio/rate-repayment/index.html" src={PortfolioSLMRate} figcaption="Rate repayment HTML demo" alt="Rate repayment HTML demo screenshot" />
            </Col>
            <Col xs={12} md={6} xl={4}>
              <Portfolio link="https://www.webdesignofboston.com/portfolio/dashboard/index.html" src={PortfolioSLMDashboard} figcaption="Dashboard HTML demo" alt="Dashboard HTML demo screenshot" />
            </Col>
          </Row>
        </Container>
      </section>
    </Container>
  );
};

export default PortfolioPage;